

import {Route, Link, Redirect } from 'react-router-dom';

import Home from './components/pages/Home';
import XHeader from "./components/header/Header.js";
import Concrete from './components/pages/Concrete';
import Stone from './components/pages/Stone';
import Remodel from './components/pages/Remodel';
import About from './components/pages/About';
import Contact from './components/pages/Contact';

import logoHeader from './img/logo/Logo_black.png'


 
import './App.css';


function App() {
  return (
    <div className="App">
        <XHeader className="hide"></XHeader>
        {/* <Home></Home> */}
   
        <div>
          <switch>
          <Route exact path="/" component={Home}></Route> {/*Added this for the main page. There may be issues when on server  */}
          <Route exact path="/Home" component={Home}></Route>
          <Route exact path="/Concrete" component={Concrete}></Route>
          <Route exact path="/Stone" component={Stone}></Route>
          <Route exact path="/Remodel" component={Remodel}></Route>
          <Route exact path="/About" component={About}></Route>
          <Route exact path="/Contact" component={Contact}></Route>

          {/* for the 404 not found */}
          <Route path="*" component={Home}/>
          </switch>
                    
   
          
          

          
        </div>

        {/* Image at in the middle of the screen  */}
        <div class=''> 
          {/* <img class="responsive-img" src={logoHeader}></img> */}
        </div>
    </div>
  )
}

export default App;

// function App() {
//   return (
    
    
//     <div className="App">


//     </div>
//   );
// }

// export default App;
